// extracted by mini-css-extract-plugin
module.exports = {"errorLogs":"styles_errorLogs__35y2M"};